import Picture from "../Picture/Picture.jsx";
import VideoEmbed from "../VideoEmbed/VideoEmbed.jsx";
import styles from "./SplitFeature.module.css";

export default function SplitFeature({
  eyebrow,
  title,
  children,
  image,
  imageAlt,
  video,
  videoTitle,
  reverse = false,
  id,
}) {
  return (
    <div className={`${styles.split} ${reverse ? styles.reverse : ""}`.trim()}>
      <div className={styles.text}>
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h2 id={id}>{title}</h2>
        <div className={styles.body}>{children}</div>
      </div>
      <div className={styles.media}>
        {video ? <VideoEmbed video={video} title={videoTitle || title} poster={image} /> : null}
        {!video && image ? (
          <Picture
            src={image}
            alt={imageAlt}
            sizes="(min-width: 64rem) 50vw, 100vw"
            className={styles.picture}
          />
        ) : null}
      </div>
    </div>
  );
}
